// extracted by mini-css-extract-plugin
export default {"dialog":"Dialog_dialog__Fp2m0","children":"Dialog_children__f1+lG","actions":"Dialog_actions__DmKbL"};